module.exports = __webpack_public_path__ + "img/login-analysis_en.2f887307.jpg";